import { Injectable } from "@angular/core";

import { UfficioDTO } from "@app/shared/dto/protocollo/ufficioDTO";
import { UfficioVO } from "@app/shared/vo/ufficioVO";
import { MapperInterface } from "@app/shared/mapper/mapper-inteface";

@Injectable()
export class MapperUfficio implements MapperInterface<UfficioDTO, UfficioVO> {

  constructor() {}

  convertDtoToVo(ufficioDTO: UfficioDTO): UfficioVO {
    console.log("MapperUfficio ufficioDTO --> ufficioVO", ufficioDTO);
    const ufficioVO = new UfficioVO();
    ufficioVO.codice = ufficioDTO.codice;
    ufficioVO.nome = ufficioDTO.nome;
    if (ufficioDTO.nome !== null && ufficioDTO.nome.length > 70) {
      ufficioVO.output =
        ufficioDTO.codice + "-" + ufficioDTO.nome.substring(0, 70) + "...";
    } else {
      ufficioVO.output = ufficioDTO.codice + "-" + ufficioDTO.nome;
    }
    return ufficioVO || new UfficioVO();
  }

  convertListVoToDto(ufficioVOList: UfficioVO[]): UfficioDTO[] {
    const ufficioDTOList = new Array<UfficioDTO>();
    if (ufficioVOList != null && ufficioVOList.length > 0) {
      ufficioVOList.forEach(ufficioVO => {
        ufficioDTOList.push(this.convertVoToDto(ufficioVO));
      });
    }
    return ufficioDTOList || new Array<UfficioDTO>();
  }
  convertListDtoToVo(dtoList: UfficioDTO[]): UfficioVO[] {
    return dtoList.map(dto => this.convertDtoToVo(dto));
  }


  convertVoToDto(ufficioVO: UfficioVO): UfficioDTO {
    console.log("[MapperUfficio] UfficioVO => UfficioDTO", ufficioVO);
    const ufficioDTO = new UfficioDTO();

    ufficioDTO.codice = ufficioVO.codice;
    ufficioDTO.nome = ufficioVO.nome;

    return ufficioDTO || new UfficioDTO();
  }
}
